// extracted by mini-css-extract-plugin
export default {"container":"styles_container__k2Fh7","title":"styles_title__7dPuX"};